import { useEffect, useState } from 'react';
import { getCachedSubjectOptions, loadSubjectOptions, subscribeSubjectOptions } from 'api/taxonomy';

/**
 * Subject names (學科) for the sidebar's 題目列表 filter sub-nav — the same set
 * as the in-page 學科 filter (top keys of taxonomyToObjectiveCascade).
 *
 * Backed by a module-level cache so the always-mounted sidebar doesn't refetch
 * per render. Subscribes to `subscribeSubjectOptions` so an add/delete in
 * 分類架構 (which calls `invalidateSubjectOptions`) refreshes the list live
 * without a reload.
 */
export default function useSubjectOptions(): string[] {
  const [subjects, setSubjects] = useState<string[]>(() => getCachedSubjectOptions() ?? []);

  useEffect(() => {
    const sync = () => setSubjects(getCachedSubjectOptions() ?? []);
    const unsubscribe = subscribeSubjectOptions(sync);
    loadSubjectOptions().then(sync);
    return unsubscribe;
  }, []);

  return subjects;
}
